import { OVERLAY_VIEWPORT_Z_INDEX_CLASS } from "../../utils/constants.js";
import { tv } from "../../variants/tv.js";
const drawerVariants = tv({
    slots: {
        backdrop: [
            'fixed inset-0 min-h-dvh bg-neutral-13/50 transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        viewport: [
            'pointer-events-none fixed inset-0 isolate flex items-end justify-center',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        popup: 'pointer-events-auto relative flex h-fit max-h-[97dvh] w-full flex-col bg-primary-1 drop-shadow-overlay-md transition-[transform,opacity] duration-[450ms] ease-[cubic-bezier(0.32,0.72,0,1)] outline-none [--drawer-scale:1] data-[ending-style]:opacity-0 data-[nested-dialog-open]:[--drawer-scale:0.9] data-[nested-drawer-open]:[--drawer-scale:0.9] data-[nested-popover-open]:[--drawer-scale:0.9] data-[starting-style]:opacity-0',
        handle: 'absolute top-2 left-1/2 z-[1] m-0 h-1 w-10 -translate-x-1/2 cursor-grab rounded-full border-0 bg-primary-5 active:cursor-grabbing data-[swiping]:cursor-grabbing',
        title: '',
        description: 'text-base leading-6 text-neutral-10',
        close: ''
    },
    variants: {
        inset: {
            true: {},
            false: {}
        },
        size: {
            sm: {
                popup: 'md:max-w-96'
            },
            md: {
                popup: 'max-w-160'
            },
            lg: {
                popup: 'max-w-240'
            },
            xl: {
                popup: 'max-w-320'
            },
            full: {}
        },
        height: {
            fit: {},
            full: {
                popup: 'h-[calc(100dvh-16px)] max-h-[calc(100dvh-16px)]'
            }
        },
        direction: {
            bottom: {
                viewport: 'items-end justify-center',
                popup: '[transform:scale(var(--drawer-scale,1))_translateY(calc(var(--drawer-snap-point-offset,0px)+var(--drawer-swipe-movement-y)))] rounded-t-2xl [--popup-corner-b:0] [--popup-corner-t:var(--radius-2xl,1rem)] data-[ending-style]:[transform:translateY(calc(100%+2px))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[starting-style]:[transform:translateY(calc(100%+2px))] data-[swiping]:duration-0'
            },
            top: {
                viewport: 'items-start justify-center',
                popup: '[transform:scale(var(--drawer-scale,1))_translateY(calc(var(--drawer-snap-point-offset,0px)+var(--drawer-swipe-movement-y)))] rounded-b-2xl [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:0] data-[ending-style]:[transform:translateY(calc(-100%-2px))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[starting-style]:[transform:translateY(calc(-100%-2px))] data-[swiping]:duration-0'
            },
            left: {
                viewport: 'items-stretch justify-start',
                popup: 'h-full max-h-dvh [transform:scale(var(--drawer-scale,1))_translateX(var(--drawer-swipe-movement-x))] rounded-r-2xl [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)] data-[ending-style]:[transform:translateX(calc(-100%-2px))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[starting-style]:[transform:translateX(calc(-100%-2px))] data-[swiping]:duration-0'
            },
            right: {
                viewport: 'items-stretch justify-end',
                popup: 'h-full max-h-dvh [transform:scale(var(--drawer-scale,1))_translateX(var(--drawer-swipe-movement-x))] rounded-l-2xl [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)] data-[ending-style]:[transform:translateX(calc(100%+2px))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[starting-style]:[transform:translateX(calc(100%+2px))] data-[swiping]:duration-0'
            }
        }
    },
    compoundVariants: [
        {
            inset: true,
            direction: 'bottom',
            class: {
                popup: 'max-h-full'
            }
        },
        {
            inset: true,
            direction: 'left',
            class: {
                popup: 'rounded-2xl [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)]'
            }
        },
        {
            inset: true,
            direction: 'right',
            class: {
                popup: 'rounded-2xl [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)]'
            }
        }
    ],
    defaultVariants: {
        direction: 'bottom',
        size: 'full',
        height: 'fit'
    }
});
const drawerSizes = Object.keys(drawerVariants.variants.size);
export { drawerSizes, drawerVariants };
